import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/Login'
import Index from '@/components/index/Index'
import AcountList from '@/components/acount/AcountList.vue'
import AcountInfo from '@/components/acount/AcountInfo.vue'
import bgConfig from '@/components/bgConfig/index.vue'
import medicalEstablishment from '@/components/medicalEstablishment/index.vue'
import organizationDetail from '@/components/medicalEstablishment/organizationDetail.vue'
import rangeManagement from '@/components/rangeManagement/index.vue'
import rangeManagementDetail from '@/components/rangeManagement/rangeManagementDetail'
import groupAccounts from '@/components/groupAccounts/index.vue'
import impowerManagement from '@/components/impowerManagement/index.vue'
import salesPromotion from '@/components/salesPromotion/index.vue'
import patientPromotion from '@/components/patientPromotion/index.vue'
import agencyAccounts from '@/components/agencyAccounts/index.vue'
import agencyDetail from '@/components/agencyAccounts/agencyDetail.vue'
import agentManage from '@/components/Agent/index.vue'
import agentDetail from '@/components/Agent/agentDetail.vue'
import agentPurchaseHistory from '@/components/Agent/agentPurchaseHistory.vue'
import visionManagement from '@/components/visionManagement/index.vue'
import visionDetail from '@/components/visionManagement/visionDetail.vue'
import visionTrainTrack from '@/components/visionTrainTrack/index.vue'
import visionTrainTrackDetail from '@/components/visionTrainTrack/visionTrainDetail'
import ReplayIframe from '@/components/visionTrainTrack/ReplayIframe.vue'
import patientManagement from '@/components/patientManagement/index.vue'
import patientManagementDetail from '@/components/patientManagement/patientManagementDetail'
import finishedTrainDetail from '@/components/patientManagement/finishedTrainDetail'
import unplayTrainSet from '@/components/patientManagement/unplayTrainSet'
import trainLogs from '@/components/trainLogs/index.vue'
import caseRecord from '@/components/patientManagement/caseRecord'
import refund from '@/components/refundMangement/index.vue'
import salesManagement from '@/components/salesManagement/index.vue'
import salesManagementDetail from '@/components/salesManagement/salesManagementDetail.vue'
import gameSales from '@/components/salesManagement/gameSales.vue'
import stationStatistics from '@/components/salesManagement/stationStatistics.vue'
import institutionsList from '@/components/salesManagement/institutionsList.vue'
import institutionsDetail from '@/components/salesManagement/institutionsDetail.vue'
import stationSalesDetail from '@/components/salesManagement/stationSalesDetail.vue'
import userinfo from '@/components/userinfo/index.vue'
import updaetUserInfo from '@/components/userinfo/updaetUserInfo.vue'
import findPassword from '@/components/userinfo/findPassword.vue'
import systemLog from '@/components/userinfo/systemLog.vue'
import visionClientVersion from '@/components/visionClientVersion/index.vue'
import StatisticsGroupOptometrist from '@/components/visionStatistics/StatisticsGroupOptometrist.vue'
import trainWeight from '@/components/trainWeight/index.vue'
import StatisticsAgent from '@/components/visionStatistics/StatisticsAgent.vue'
import stimulusMode from "@/components/bgConfig/stimulusMode"
import stimulusConfig from "@/components/bgConfig/stimulusConfig"
import stimulusGames from "@/components/bgConfig/stimulusGames"
import StatisticsManagerRange from '@/components/visionStatistics/statisticManagerRange.vue'
import StatisticsManagerAgent from '@/components/visionStatistics/statisticManagerAgent.vue'
import gameIntroduce from '@/components/gameIntroduce/index.vue'
import gameReplayAnalysis from '@/components/gameReplayAnalysis/index.vue'
import trainWeekFeedback from '@/components/trainWeekFeedback/index.vue'
Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      redirect: {
        name: 'login'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/findPassword',
      name: 'findPassword',
      component: findPassword
    },
    {
      path: '/index',
      name: 'index',
      component: Index,
      children: [{
          path: 'acountList/:urlPage/:urlSearchType/:urlSearchText',
          component: AcountList,
          props: true
        },
        {
          path: 'acountInfo/:id/:urlPage/:urlSearchType/:urlSearchText',
          component: AcountInfo,
          props: true
        },
        {
          path: 'systemLog',
          component: systemLog,
          props: true

        },
        {
          path: 'userinfo/updaetUserInfo/:type',
          component: updaetUserInfo
        },
        {
          path: 'userinfo',
          component: userinfo
        },
        {
          path: 'stimulusMode',
          component: stimulusMode
        },
        {
          path: 'trainWeight',
          component: trainWeight
        }, {
          path: 'stimulusConfig',
          component: stimulusConfig,
        },
        {
          path: 'stimulusGames',
          component: stimulusGames,
        },
        {
          path: 'bgConfig',
          component: bgConfig
        },
        {
          path: 'refund',
          component: refund
        },
        {
          path: 'StatisticsGroupOptometrist',
          component: StatisticsGroupOptometrist
        }, {
          path: 'StatisticsAgent',
          component: StatisticsAgent
        },
        {
          path: 'StatisticsManagerRange',
          component: StatisticsManagerRange,
        },
        {
          path: 'StatisticsManagerAgent',
          component: StatisticsManagerAgent,
        },
        {
          path: 'visionClientVersion',
          component: visionClientVersion
        },
        {
          path: 'salesManagement/salesManagementDetail/:accountId',
          component: salesManagementDetail
        },
        {
          path: 'salesManagement/gameSales/:accountId',
          component: gameSales
        },
        {
          path: 'salesManagement',
          component: salesManagement
        },
        {
          path: 'institutionsList/institutionsDetail/:accountId',
          component: institutionsDetail
        },
        {
          path: 'stationStatistics/stationSalesDetail/:stationId/:time',
          component: stationSalesDetail
        },
        {
          path: 'institutionsList',
          component: institutionsList
        },
        {
          path: 'stationStatistics',
          component: stationStatistics
        },
        {
          path: 'agentPurchaseHistory',
          component: agentPurchaseHistory
        },
        {
          path: 'medicalEstablishment/organizationDetail/:stationId',
          component: organizationDetail,
        },
        {
          path: 'medicalEstablishment',
          component: medicalEstablishment,
        },
        {
          path: 'rangeManagement/rangeManagementDetail/:regionId',
          component: rangeManagementDetail,
        },
        {
          path: 'rangeManagement',
          component: rangeManagement,
        },
        {
          path: 'groupAccounts',
          component: groupAccounts,
        },
        {
          path: 'impowerManagement',
          component: impowerManagement,
        },
        {
          path: 'salesPromotion',
          component: salesPromotion
        },
        {
          path: 'patientPromotion',
          component: patientPromotion
        },
        {
          path: 'agencyAccounts/agencyDetail/:accountId',
          component: agencyDetail,
        },
        {
          path: 'agencyAccounts',
          component: agencyAccounts,
        },
        {
          path: 'agentManage/agentDetail/:agentId',
          component: agentDetail,
        },
        {
          path: 'agentManage',
          component: agentManage,
        },
        {
          path: 'visionManagement/visionDetail/:accountId',
          component: visionDetail,
        },
        {
          path: 'visionManagement',
          component: visionManagement,
        },
        {
          path: 'visionTrainTrack/visionTrainTrackDetail/:patientId/:stationId/:trackId',
          component: visionTrainTrackDetail,
          props: true,
          children: [{
            path: ':id/:type',
            component: ReplayIframe,
            props: true
          }]
        },
        {
          path: 'visionTrainTrack',
          component: visionTrainTrack,
        },
        {
          path: 'patientManagement',
          component: patientManagement,
          props: true,
        },
        {
          path: 'trainWeekFeedback',
          component: trainWeekFeedback,
        },
        {
          path: 'patientManagement/patientManagementDetail/:patientId/:stationId',
          component: patientManagementDetail,
          props: true,
        },
        {
          path: 'patientManagement/patientManagementDetail/:patientId/:stationId/caseRecord/:patientCaseId',
          component: caseRecord,
          props: true,
        },
        {
          path: 'patientManagement/patientManagementDetail/:patientId/:stationId/finishedTrainDetail/:trainingId/:gameId/:patientAge',
          component: finishedTrainDetail,
          props: true,
        },
        {
          path: 'patientManagement/patientManagementDetail/:patientId/:stationId/unplayTrainSet/:trainingId/:gameType/:gameId/:level/:trainEye/:userInfoLabel/:stimulusLevel',
          component: unplayTrainSet,
          props: true,
        },
        {
          path: 'trainLogs',
          component: trainLogs,
        },
        {
          path: 'gameIntroduce',
          component: gameIntroduce,
        },
        {
          path: 'gameReplayAnalysis/:id/:type',
          component: ReplayIframe,
        },
        {
          path: 'gameReplayAnalysis',
          component: gameReplayAnalysis,
          props: true,
        }
      ]
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js